import { render } from "./ConfigurationPage.vue?vue&type=template&id=2f1a6d35&scoped=true&ts=true"
import script from "./ConfigurationPage.vue?vue&type=script&lang=ts"
export * from "./ConfigurationPage.vue?vue&type=script&lang=ts"

import "./ConfigurationPage.vue?vue&type=style&index=0&id=2f1a6d35&scoped=true&lang=css"
import "./ConfigurationPage.vue?vue&type=style&index=1&id=2f1a6d35&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f1a6d35"]])

export default __exports__